module.exports = __webpack_public_path__ + "static/img/slide4.cb9ee77e.jpg";